import { useNavigate } from "react-router";

const ReviewText = ({ text }:{text:any}) => {

    const navigate = useNavigate()

  const words = text.split(" ");
  const isLong = words.length > 15;

  const handleReadMore = () => {
    console.log("Read more clicked");
    navigate('/app/reviewdetails', {
  state: { heading: 'Feedback Details', iconClass: 'bi bi-chevron-left' },
})
  };

  return (
    <p className="mt-3 text-muted" style={{ fontSize: "0.9rem" }}>
      {!isLong ? (
        text
      ) : (
        <>
          {words.slice(0, 50).join(" ")}...{" "}
          <span
            onClick={handleReadMore}
            style={{ color: "#007bff", cursor: "pointer" }}
          >
            Read more
          </span>
        </>
      )}
    </p>
  );
};

export default ReviewText;
